<template>
  <div class="error-default">
    <div class="error-default__container">
      <div class="error-default__container__error">
        500
      </div>
      <div class="error-default__container__title">
        {{ $t('errors.default.title') }}
      </div>
      <div class="error-default__container__description">
        {{ $t('errors.default.description') }}
      </div>
      <div class="error-default__container__details" v-if="error">{{ $t('errors.default.details') }} "{{ error }}"</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorDefault',
  props: {
    error: {
      required: true,
    },
  },
}
</script>

<style lang="scss">
.error-default {
  display: flex;
  background-color: $generic-color-bg;
  min-height: 100vh;

  &__container {
    margin: auto;
    padding: $gutter-sm;

    @media (min-width: $screen-sm) {
      padding: $gutter-md;
    }

    &__error {
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 1;
      font-size: 6rem;
      font-weight: bold;

      @media (min-width: $screen-sm) {
        font-size: 10rem;
      }

      &__img {
        margin: -10px 10px 0;
        height: 100px;

        @media (min-width: $screen-sm) {
          margin: -20px 20px 0;
          height: 150px;
        }
      }
    }

    &__title {
      margin-top: 24px;
      text-align: center;
      line-height: 1;
      font-size: 2rem;
      font-weight: bold;

      @media (min-width: $screen-sm) {
        font-size: 3rem;
      }
    }

    &__description {
      margin-top: $spacing-md;
      text-align: center;
      font-size: $font-size-default;

      @media (min-width: $screen-sm) {
        font-size: 1rem;
      }
    }

    &__details {
      margin-top: $spacing-md;
      text-align: center;
      color: rgba($generic-color-text, 0.6);
      font-size: $font-size-sm;
    }
  }
}
</style>
